/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Trust_Window_Warning_TitleInputs */



/**
* | output |
* | --- |
* | "Skip confirmation clicks?" |
*
* @param {Chat_Tool_Trust_Window_Warning_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_trust_window_warning_title = /** @type {((inputs?: Chat_Tool_Trust_Window_Warning_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Trust_Window_Warning_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bestätigungs-Klicks überspringen?")
	return /** @type {LocalizedString} */ ("Skip confirmation clicks?")
});